import { render, staticRenderFns } from "./SiteNavItem.vue?vue&type=template&id=8df62a2e&scoped=true"
import script from "./SiteNavItem.vue?vue&type=script&lang=ts"
export * from "./SiteNavItem.vue?vue&type=script&lang=ts"
import style0 from "./SiteNavItem.vue?vue&type=style&index=0&id=8df62a2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df62a2e",
  null
  
)

export default component.exports